angular.
module("dx.webapp.droparea", [
	"digiexam.services",

	"angularFileUpload",
]);
